export type Project = {
  id: string;
  slug: string;
  name: string;
  repo: string;
  repoUrl: string;
  description: string;
  category: string;
  license: string;
  stars: number;
  imageUrl: string;
  publicHost: string;
  status: "ready" | "maintenance" | "disabled";
  healthStatus: "healthy" | "degraded" | "down";
};

export const fallbackProjects: Project[] = [
  {
    id: "project_open_design",
    slug: "open-design",
    name: "Open Design",
    repo: "nexu-io/open-design",
    repoUrl: "https://github.com/nexu-io/open-design",
    description: "本地优先的开源 AI 设计工具，可生成原型、落地页、仪表盘与演示内容。",
    category: "设计工具",
    license: "Apache-2.0",
    stars: 82800,
    imageUrl: "/assets/open-design-home.png",
    publicHost: "try-open-design.autoclaude.cn",
    status: "ready",
    healthStatus: "healthy",
  },
  {
    id: "project_open_notebook",
    slug: "open-notebook",
    name: "Open Notebook",
    repo: "lfnovo/open-notebook",
    repoUrl: "https://github.com/lfnovo/open-notebook",
    description: "开源的 AI 笔记工作台，支持采集资料、构建笔记本、智能问答与播客式内容创作。",
    category: "知识管理",
    license: "MIT",
    stars: 36281,
    imageUrl: "/assets/open-notebook-main.webp",
    publicHost: "http://172.16.18.11:8502/",
    status: "ready",
    healthStatus: "healthy",
  },
  {
    id: "project_pixelle_video",
    slug: "pixelle-video",
    name: "Pixelle-Video",
    repo: "ATH-MaaS/Pixelle-Video",
    repoUrl: "https://github.com/ATH-MaaS/Pixelle-Video",
    description: "AI 全自动短视频引擎，输入主题即可完成文案、配图、配音与视频合成。",
    category: "视频生成",
    license: "Apache-2.0",
    stars: 26385,
    imageUrl: "/assets/pixelle-video-main.webp",
    publicHost: "http://172.16.18.11:8501/",
    status: "ready",
    healthStatus: "healthy",
  },
  {
    id: "project_motion_anything",
    slug: "motion-anything",
    name: "Motion Anything",
    repo: "nexu-io/motion-anything",
    repoUrl: "https://github.com/nexu-io/motion-anything",
    description: "AI 驱动的开源动效工具，描述一句话即可生成网页、幻灯片、视频与 App UI 动效。",
    category: "动效工具",
    license: "Apache-2.0",
    stars: 649,
    imageUrl: "/assets/motion-anything-main.webp",
    publicHost: "http://172.16.18.11:3002/",
    status: "ready",
    healthStatus: "healthy",
  },
];
